import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Personnel.css';

const StationDistribution = () => {
  const navigate = useNavigate();

  return (
    <div className="personnel-container">
      <div className="back-button-container">
        <button onClick={() => navigate('/personnel')} className="back-button">
          ← العودة للأفراد
        </button>
      </div>

      <div className="personnel-header">
        <h1>📊 التوزيع على المحطات</h1>
        <p>جدول توزيع الموظفين على المحطات</p>
      </div>

      <div className="coming-soon">
        <div className="coming-soon-icon">🚧</div>
        <h2>قيد التطوير</h2>
        <p>سيتم إضافة هذه الميزة قريباً</p>
      </div>
    </div>
  );
};

export default StationDistribution;